


























import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { mdiClose } from '@mdi/js'
import {
  ICatalogFilterItem,
  ICatalogFilterResetItem,
} from '~/assets/interfaces/catalog'
import '~/assets/scss/v-tooltip.scss'
import MixinGeneral from '~/assets/mixins/general'
import { filterUrl } from '~/assets/filters/url'
import { filterPrice } from '~/assets/filters/price'

const typeOfFields = ['checkbox', 'image']

@Component({
  components: {
    ComponentIcon: () => import('~/components/icon/icon.vue'),
  },
})
export default class ComponentCatalogFilterReset extends mixins(MixinGeneral) {
  @Prop({ type: Array, default: () => [] }) items!: ICatalogFilterItem[]

  private icons = {
    mdiClose,
  }

  private get itemsRender() {
    const temp: ICatalogFilterResetItem[] = []
    this.items.forEach((item) => {
      if (item.type === 'range') {
        const query = { ...this.$route.query }
        if (query[item.key]) {
          temp.push({
            type: item.type,
            title: item.title,
            key: item.key,
            value: '',
            valueTitle: `от ${filterPrice(item.options.min)} до ${filterPrice(
              item.options.max
            )}`,
          })
        }
      } else if (typeOfFields.includes(item.type) && item.items) {
        item.items.forEach((item2) => {
          if (item2.active) {
            temp.push({
              type: item.type,
              title: item.title,
              key: item.key,
              value: item2.value,
              valueTitle: item2.title,
            })
          }
        })
      }
    })
    return temp
  }

  private async changeHandler(key: string, typeParam: string, value: string) {
    let newE = ''

    const query = { ...this.$route.query }

    if (typeParam === 'range') {
      delete query[key]
    } else {
      const queryKey = query[key] as string
      if (typeOfFields.includes(typeParam) && queryKey && queryKey.length > 0) {
        const temp = queryKey.split(';')
        const index = temp.indexOf(value)

        if (index !== -1) {
          temp.splice(index, 1)
        }
        newE = temp.join(';')
        query[key] = newE
      }
    }

    if (query.page) {
      query.page = '1'
    }
    await this.$router.push({
      path: filterUrl(this.$route.path),
      query,
    })
  }

  private async resetAll() {
    const query: Record<string, string> = {}
    if (this.$route.query.page) {
      query.page = this.$route.query.page.toString()
    }
    if (this.$route.query.text) {
      query.text = this.$route.query.text.toString()
    }
    if (this.$route.query.category) {
      query.category = this.$route.query.category.toString()
    }
    await this.$router.push({
      path: filterUrl(this.$route.path),
      query,
    })
  }
}
